
import {GetPortalTasksForUser} from '../../../src/WorkControllerApiClient';
import { Dictionary, groupBy, maxBy, minBy, sortBy } from 'lodash';

interface SortingMethod {
    (a: TaskCard, b: TaskCard): number;
}
interface GroupingMethod {
    (a: IPortalTaskDTO): string;
}

export const ACTIVE_STATUS = 0;
export const INVALID_STATUS = 1;
export const COMPLETED_STATUS = 2;

export class TaskCard {
    Status:string;

    constructor(
        /** Unique identifier for this particular grouping of tasks (usually workItemId) */ 
        public GroupKey: string, 
        /** List of tasks associated with this card */
        public Tasks: IPortalTaskDTO[], 
        /** Contains latest updates for card title, body, etc */
        public CardProjection: ITaskCardProjectionDTO, 
        /** The method used to create this card */
        public GroupMethod: GroupBy) {

        if(Tasks.map(x => x.Status).indexOf(ACTIVE_STATUS) != -1){ 
            this.Status = "Active";
        }
        else if(Tasks.map(x => x.Status).every(x => x == COMPLETED_STATUS))
        {
            this.Status = "Complete";
        }
        else
        {
            this.Status = "Error";
        }
    }
}

export enum SortBy {
    Alphabetical,
    LastUpdated,
}

export enum GroupBy {
    WorkItemId = 0,
    DayCreated = 1
}

const SORT_METHODS: SortingMethod[] = [
    (a, b) => a.CardProjection.CardTitle.localeCompare(b.CardProjection.CardTitle),
    (a, b) => mostRecentlyAddedTaskComparer(a, b),
];

const GROUP_METHODS: GroupingMethod[] = [
    (ptask => ptask.KWorkItemRootId),
    (ptask => { 
        let date = new Date(ptask.DateCreated); 
        return date.toDateString();
    }),
];

function mostRecentlyAddedTaskComparer(a: TaskCard, b: TaskCard) {
    let tasksA = a.Tasks;
    let tasksB = b.Tasks;
    let combined = tasksA.concat(tasksB);
    let lastUpdatedTask = maxBy(combined, ptask => Date.parse(ptask.DateCreated));
    return tasksA.includes(lastUpdatedTask) ? -1 : 1
}

export function GenerateCardsFromTasks(portalTasks: IPortalTaskDTO[], cardProjections: ITaskCardProjectionDTO[], groupMethod: GroupBy, sortMethod: SortBy): TaskCard[] { 
    let groups = groupTasks(portalTasks, groupMethod);
    let cardList = groupsToCards(groups, cardProjections, groupMethod);

    cardList.forEach(setDefaultCardTitleIfNeeded);
    
    return sortTaskCards(cardList, sortMethod);
}

function groupTasks(tasks: IPortalTaskDTO[], by: GroupBy): Dictionary<IPortalTaskDTO[]> {
    let groupedTasks = groupBy(tasks, GROUP_METHODS[by]);

    return groupedTasks;
}

function groupsToCards(groupedTasks: Dictionary<IPortalTaskDTO[]>, cardProjections: ITaskCardProjectionDTO[], groupMethod: GroupBy) {
    return Object.keys(groupedTasks).map(
        taskGroupId => new TaskCard(
            taskGroupId, 
            groupedTasks[taskGroupId], 
            cardProjections.find(c => c.WorkItemId == taskGroupId) || getDefaultCard(taskGroupId), 
            groupMethod)
    );
}

function sortTaskCards(taskCards:TaskCard[], by: SortBy): TaskCard[] {
    return taskCards.sort(SORT_METHODS[by]);
}

function getDefaultCard(taskGroupId: string) {
    return {
        WorkItemId: "",
        CardTitle: "",
        CardBody: ""
    };
}

function setDefaultCardTitleIfNeeded(card: TaskCard) {
    if (!card.CardProjection.CardTitle) {
        card.CardProjection.CardTitle = card.GroupKey;
    }
}